import {
  IconAlertTriangle,
  IconCircle,
  IconCircleCheck,
  IconHelpCircle,
  IconInfoCircle,
  IconLock,
  IconShieldOff,
  IconClock,
  IconX,
} from '@tabler/icons-react';
import type { IconComponent } from './iconTypes';

export const statusIcons = {
  success: IconCircleCheck,
  warning: IconAlertTriangle,
  error: IconX,
  info: IconInfoCircle,
  pending: IconClock,
  locked: IconLock,
  permissionDenied: IconShieldOff,
  neutral: IconCircle,
  help: IconHelpCircle,
} as const satisfies Record<string, IconComponent>;

export type StatusIconName = keyof typeof statusIcons;
